import MainFooter from '../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../components/mazraeKit/headers/homeHeader';
import NotFoundImage from '../../assets/image/404.png';
import Button from '../../components/button';
import {useNavigate} from 'react-router';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex w-full h-full flex-col justify-between">
      <CustomHeader
        preIcon="icon-nameArrow---Right"
        title="فروشگاه مزرعه"
        backRoute="/home"
      />
      <div className="flex bg-white w-full flex-col  justify-center h-full align-center  px-3">
        <div className="flex w-full justify-center items-center gap-4 flex-col">
          <img src={NotFoundImage} alt="page-not-found" />
          <p className="text-gray-800 text-lg font-Regular">
            صفحه مورد نظر پیدا نشد
          </p>
          <Button onClick={() => navigate('/home')}>بازگشت به خانه</Button>
        </div>
      </div>
      <MainFooter />
    </div>
  );
};

export default NotFound;
